const state = {
    dataInsert: [],
    code: ""
}

const mutations = {
  SET_DATA (state, dataInsert) {
    state.dataInsert = dataInsert
  },
  SET_CODE(state, code) {
    state.code = code
  }
}

const actions = {
    updateData({commit}, obj) {
      commit('SET_DATA', obj)
    },
    updateCode({commit}, obj) {
      commit("SET_CODE", obj)
    }
  }

const getters = {
  getDataInsert(state) {
    return state.dataInsert
  },
  getCode(state) {
    return state.code
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}


// WEBPACK FOOTER //
// ./src/stores/modules/applyCourse.js